import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CollectionDto } from '../model/collection.model';
import { environment } from '../../environments/environment';
import { HttpClientHelper } from './http-client-helper.service';
import { firstValueFrom, map, tap } from 'rxjs';
import { ConsoleLoggerService } from './console-logger.service';
import { GridRequest } from '../model/grid-request.model';
import { CostCenterListItem } from '../model/cost-center-list-item.model';


@Injectable({
  providedIn: 'root'
})
export class CostCenterService {

  constructor(private http: HttpClient,
              private httpClientHelper: HttpClientHelper,
              private log: ConsoleLoggerService) {
  }

  getCostCenters() {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/costCenters`;
    const observable = this.http.get<CollectionDto<CostCenterListItem>>(url, { params: params })
      .pipe(tap(r => this.log.debug('costCenters: ', r)))
      .pipe(map(c => c.items))

    return firstValueFrom(observable)
  }

  getPagedCostCenters(request: GridRequest) {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/costCenters/paged`;
    const observable = this.http.post<CollectionDto<CostCenterListItem>>(url, request, { params: params })
      .pipe(tap(r => this.log.debug('costCenters: ', r)));
    return firstValueFrom(observable);
  }

  saveCostCenter(documentType: CostCenterListItem) {
    const params = this.httpClientHelper.createHttpParams();
    let url = environment.apiUrl + `/costCenters`;
    const observable = this.http.post<CostCenterListItem>(url, documentType, { params: params })
      .pipe(tap(r => this.log.debug('costCenters save response: ', r)));

    return firstValueFrom(observable);
  }

  updateCostCentersStatus(id: number, active: boolean) {
    let params = this.httpClientHelper.createHttpParams();
    params = params.append('active', active);

    let url = environment.apiUrl + `/costCenters/${id}/status`;
    const observable = this.http.put<boolean>(url, null, { params: params })
      .pipe(tap(r => this.log.debug('CostCenters updated: ', r)))

    return firstValueFrom(observable)
  }

}
